<template>
  <wow-card :title="`WOW Kit Ordering`" :btnText="`Initiate Order`" :icon="`mdi-basket`" :screenType="`wowKitOrdering`"
    @click="openOrderInitiateDialog" :isSuperAdmin="isSuperAdmin" :WOWKIT_MAKER='WOWKIT_MAKER'>
    <wow-filter :reloadFlag="reloadListFlag" :moduleType="`kitOrdering`" :WOWKIT_ZSM_APPROVED="WOWKIT_ZSM_APPROVED" :WOWKIT_APPROVED="WOWKIT_APPROVED" :isSuperAdmin="isSuperAdmin" :centerArray='franchisee'
      :initiateOrderListAPI='recallInitiateOrderList' @setInitiatedOrderDetails='setInitiatedOrderDetails' />
    <wow-order-table :initiatedOrderList='initiatedOrderList' :WOWKIT_MAKER="WOWKIT_MAKER" :WOWKIT_ZSM_APPROVED="WOWKIT_ZSM_APPROVED"
      :WOWKIT_APPROVED="WOWKIT_APPROVED" @reloadList="setReloadListFlag" />
    <wow-dialog :fullscreen="true" :title="`Initiate Order`" v-model="orderInitiateDialog" :persistent="true"
      @close="closeOrderInitiateDialog">
      <wow-initiate-order v-if="orderInitiateDialog"
        @closeOrderInitiateDialog="closeDialogOnOrderInitiated"></wow-initiate-order>
    </wow-dialog>
  </wow-card>
</template>
<script>
import Utils from '@/utils'
import CONSTANTS from '@/utils/constants'
import Stores from '@/stores'
import WowCard from '@/components/Orders/WowKitOrdering/kitComponents/vCard'
import WowFilter from '@/components/Orders/WowKitOrdering/kitComponents/filter/filterComponent'
import WowDialog from '@/components/Orders/WowKitOrdering/kitComponents/dialog/dialogComponent'
import WowInitiateOrder from '@/components/Orders/WowKitOrdering/kitComponents/initiateOrder'
import WowOrderTable from '@/components/Orders/WowKitOrdering/kitComponents/table/orderTable'
export default {
  name: 'wowKitOrdering',
  components: {
    WowCard,
    WowFilter,
    WowDialog,
    WowInitiateOrder,
    WowOrderTable
  },
  data () {
    return {
      orderInitiateDialog: false,
      franchisee: [],
      initiatedOrderList: [],
      WOWKIT_ZSM_APPROVED: false,
      WOWKIT_APPROVED: false,
      recallInitiateOrderList: false,
      isSuperAdmin: false,
      WOWKIT_MAKER: this.checkModuleAccess('WOW_KIT_MAKER'),
      reloadListFlag: false
    }
  },
  async created () {
    if (Stores.user.me.superAdmin) {
      this.isSuperAdmin = Stores.user.me.superAdmin
    }
    if (Stores.user.roles) {
      let getRolesArray = Stores.user.roles
      getRolesArray.forEach(item => {
        if (item.role === CONSTANTS.WOW_KIT_APPROVER_ROLE.zsmApprove) {
          this.WOWKIT_ZSM_APPROVED = true
        } else if (item.role === CONSTANTS.WOW_KIT_APPROVER_ROLE.approve) {
          this.WOWKIT_APPROVED = true
        }
      })
    }
    await this.getFranchiseeList()
  },
  methods: {
    openOrderInitiateDialog: function () {
      this.orderInitiateDialog = true
      this.recallInitiateOrderList = false
    },
    closeOrderInitiateDialog: function () {
      this.orderInitiateDialog = false
      this.recallInitiateOrderList = false
    },
    closeDialogOnOrderInitiated: function () {
      this.orderInitiateDialog = false
      this.recallInitiateOrderList = true
    },
    getFranchiseeList: async function () {
      try {
        this.isLoading = true
        const res = await http.get(`${CONSTANTS.API_URL}/api/franchisee/active`)
        if (res.status === 200) {
          this.franchisee = res.data.rows
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      }
    },
    setInitiatedOrderDetails: function (orderList) {
      this.initiatedOrderList = orderList
    },
    checkModuleAccess: function (moduleName) {
      return Utils.helper.checkAccessByModule(this.$route, moduleName)
    },
    setReloadListFlag: function (reloadStatus) {
      this.reloadListFlag = reloadStatus
    }
  }
}
</script>
